import { GameTypeConstant } from '../constant/game.type.constant';

/**
 * Service for decoding game ID from URL
 * Game ID format: 16 characters (e.g. "0000000000000604")
 *
 * Character ranges:
 * - Characters 1-4: Reserved for future use
 * - Characters 5-8: Bet limit ID
 * - Characters 9-10: Reserved for future use
 * - Characters 11-12: Table type
 * - Characters 13-16: Game type
 *
 * Samples:
 * - 0000000300LC0604 - Live Casino, FC21 Or Nothing
 * - 0000000000LD0605 - Live Dealer, FCG Baccarat
 * - 0000000300LC0604 - Bet Limit 3, Live Casino, FC21 Or Nothing
 * - 0000000300PT0604 - Bet Limit 3, Private Table, FC21 Or Nothing
 *
 * login urls:
 *
 * FC21, LC, Bet Limit 1:
 * 0000000100LC0604
 * https://my.staging.fcgcc.com/cgibin/PartnerFCGRNGGameServlet/login?gametypeId=rngfcg21ornothing&betlimit=1&gamename=fc21&lang=en&serverURL=rng.staging.fcgcc.com&rewriteURL=!signin/viewer/mobile/lobby!fc21tables_livecasino_5&historyURL=!signin/viewer/mobile/lobby!fc21tables_livecasino_5&newtable=0&flylogin=false&sessiontoken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiYmFiMzRkNTYwZTIwNGJjMSIsImNhc2lub19pZCI6ImZjYzEyMzQ1Njc4OTBhYmMiLCJmdW51c2VyX2lkIjoiZTkxOTFiNTFmNzBiNDI1NSIsInByYWN0aWNlX21vZGUiOmZhbHNlLCJleHAiOjE3NDQ4MDM0MzAuODU1NjQxLCJ0b2tlbl90eXBlIjoiYWNjZXNzIn0.UAWFJLzcR-zOnOs5cE0lelh6vY2-6GFJF26fv2Xp92c&seat=5&gdt=1744717360312&initialusertype=PLAY&fullscreen=false&rcenable=false
 *
 * FC21, LC, Bet Limit 3:
 * 0000000300LC0604
 * https://my.staging.fcgcc.com/cgibin/PartnerFCGRNGGameServlet/login?gametypeId=rngfcg21ornothing&betlimit=3&gamename=fc21&lang=en&serverURL=rng.staging.fcgcc.com&rewriteURL=!signin/viewer/mobile/lobby!fc21tables_livecasino_5&historyURL=!signin/viewer/mobile/lobby!fc21tables_livecasino_5&newtable=0&flylogin=false&sessiontoken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiYmFiMzRkNTYwZTIwNGJjMSIsImNhc2lub19pZCI6ImZjYzEyMzQ1Njc4OTBhYmMiLCJmdW51c2VyX2lkIjoiZTkxOTFiNTFmNzBiNDI1NSIsInByYWN0aWNlX21vZGUiOmZhbHNlLCJleHAiOjE3NDQ4MDM0MzAuODU1NjQxLCJ0b2tlbl90eXBlIjoiYWNjZXNzIn0.UAWFJLzcR-zOnOs5cE0lelh6vY2-6GFJF26fv2Xp92c&seat=5&gdt=1744717403499&initialusertype=PLAY&fullscreen=false&rcenable=false
 *
 *
 * FC21, PT, Bet Limit 1:
 * 0000000100PT0604
 * https://my.staging.fcgcc.com/cgibin/PartnerFCGRNGGameServlet/login?gametypeId=rngfcg21ornothing&betlimit=6&gamename=fc21&lang=en&serverURL=rng.staging.fcgcc.com&rewriteURL=!signin/viewer/mobile/lobby!fc21tables_private_5&historyURL=!signin/viewer/mobile/lobby!fc21tables_private_5&newtable=0&flylogin=false&sessiontoken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiYmFiMzRkNTYwZTIwNGJjMSIsImNhc2lub19pZCI6ImZjYzEyMzQ1Njc4OTBhYmMiLCJmdW51c2VyX2lkIjoiZTkxOTFiNTFmNzBiNDI1NSIsInByYWN0aWNlX21vZGUiOmZhbHNlLCJleHAiOjE3NDQ4MDM0MzAuODU1NjQxLCJ0b2tlbl90eXBlIjoiYWNjZXNzIn0.UAWFJLzcR-zOnOs5cE0lelh6vY2-6GFJF26fv2Xp92c&seat=5&gdt=1744717182785&initialusertype=PLAY&fullscreen=false&rcenable=false
 *
 * FC21, PT, Bet Limit 3:
 * 0000000300PT0604
 * https://my.staging.fcgcc.com/cgibin/PartnerFCGRNGGameServlet/login?gametypeId=rngfcg21ornothing&betlimit=8&gamename=fc21&lang=en&serverURL=rng.staging.fcgcc.com&rewriteURL=!signin/viewer/mobile/lobby!fc21tables_private_5&historyURL=!signin/viewer/mobile/lobby!fc21tables_private_5&newtable=0&flylogin=false&sessiontoken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiYmFiMzRkNTYwZTIwNGJjMSIsImNhc2lub19pZCI6ImZjYzEyMzQ1Njc4OTBhYmMiLCJmdW51c2VyX2lkIjoiZTkxOTFiNTFmNzBiNDI1NSIsInByYWN0aWNlX21vZGUiOmZhbHNlLCJleHAiOjE3NDQ4MDM0MzAuODU1NjQxLCJ0b2tlbl90eXBlIjoiYWNjZXNzIn0.UAWFJLzcR-zOnOs5cE0lelh6vY2-6GFJF26fv2Xp92c&seat=5&gdt=1744717305919&initialusertype=PLAY&fullscreen=false&rcenable=false
 *
 *
 * FC21, LD, Bet Limit 1:
 * 0000000100LD0606
 * https://my.demo.fcgcc.com/cgibin/LdsGameServlet/login?tableId=fcg21nv8sv7rk4jk&betlimitId=1&gameTypeId=0000000000000606&sessiontoken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiZTA5YmZjMXlxc2I2YWFwMyIsImNhc2lub19pZCI6ImZjYzEyMzQ1Njc4OTBhYmMiLCJmdW51c2VyX2lkIjoiMHE1OGUzMHBhMjlhYzFmdCIsInByYWN0aWNlX21vZGUiOmZhbHNlLCJleHAiOjE3NDQ3OTU2MTAuMjExNjYxLCJ0b2tlbl90eXBlIjoiYWNjZXNzIn0.7M3ukBFVmrG0lrggr6ZQ1A5BLlWLx9mIme7_3rvidGE&scheme=https&serverName=my.demo.fcgcc.com&flylogin=false&fullscreen=false&rcenable=false&gameName=livefc21&lang=en&serverURL=rng.demo.fcgcc.com&rewriteURL=!signin/viewer/mobile/lobby!fc21tables_livedealer_5&gdt=1744718047485&initialusertype=PLAY
 *
 * FC21, LD, Bet Limit 4:
 * 0000000400LD0606
 * tableId: fcg21nv8sv7rk3jk
 * https://my.demo.fcgcc.com/cgibin/LdsGameServlet/login?tableId=fcg21nv8sv7rk4jk&betlimitId=4&gameTypeId=0000000000000606&sessiontoken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiZTA5YmZjMXlxc2I2YWFwMyIsImNhc2lub19pZCI6ImZjYzEyMzQ1Njc4OTBhYmMiLCJmdW51c2VyX2lkIjoiMHE1OGUzMHBhMjlhYzFmdCIsInByYWN0aWNlX21vZGUiOmZhbHNlLCJleHAiOjE3NDQ3OTU2MTAuMjExNjYxLCJ0b2tlbl90eXBlIjoiYWNjZXNzIn0.7M3ukBFVmrG0lrggr6ZQ1A5BLlWLx9mIme7_3rvidGE&scheme=https&serverName=my.demo.fcgcc.com&flylogin=false&fullscreen=false&rcenable=false&gameName=livefc21&lang=en&serverURL=rng.demo.fcgcc.com&rewriteURL=!signin/viewer/mobile/lobby!fc21tables_livedealer_5&gdt=1744717950662&initialusertype=PLAY
 *
 *
 * missing: tableId=fcg21nv8sv7rk4jk, scheme=https, serverName=my.demo.fcgcc.com
 *
 * Baccarat, PT, Limit 1:
 * 0000000100PT0605
 * https://my.demo.fcgcc.com/cgibin/PartnerFCGRNGGameServlet/login?gametypeId=rngfcgbaccarat&betlimit=6&gamename=fcb&lang=en&serverURL=rng.demo.fcgcc.com&rewriteURL=!signin/viewer/mobile/lobby!fcbtables_private_1&historyURL=!signin/viewer/mobile/lobby!fcbtables_private_1&newtable=0&flylogin=false&sessiontoken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiZTA5YmZjMXlxc2I2YWFwMyIsImNhc2lub19pZCI6ImZjYzEyMzQ1Njc4OTBhYmMiLCJmdW51c2VyX2lkIjoiMHE1OGUzMHBhMjlhYzFmdCIsInByYWN0aWNlX21vZGUiOmZhbHNlLCJleHAiOjE3NDQ4NzYxOTUuNTIxNTAyLCJ0b2tlbl90eXBlIjoiYWNjZXNzIn0.8a8470o-4YTBs3Y12DfwA8ZSuGBlqMbL7EgB1ZQ4KjE&seat=1&gdt=1744791018280&initialusertype=PLAY&fullscreen=false&rcenable=false
 *
 *
 */

/**
 * Get game parameters needed for LoadGameService.loadGame() from gameId
 * @param gameId Game ID string
 * @returns Object with parameters needed for loading the game or null if invalid gameId
 */
export function getGameParameters(gameId: string): {
  gameName: string;
  gameFeature: string;
  betLimitId: string;
  seatAvailable: number;
  roomId?: string;
  newTable?: number;
  rewriteURL?: string;
  historyURL?: string;
  tableId?: string;
  tableType?: string;
} | null {
  console.log('Validating game ID:', gameId);

  // Simple mapping for bet limits
  const betLimitMap = {
    LD: {
      '0000': 'Lobby',
      '0001': '1',
      '0002': '2',
      '0003': '3',
      '0004': '4',
      '0005': '5',
    },
    LC: {
      '0000': 'Lobby',
      '0001': '1',
      '0002': '2',
      '0003': '3',
      '0004': '4',
      '0005': '5',
    },
    PT: {
      '0000': 'Lobby',
      '0001': '6',
      '0002': '7',
      '0003': '8',
      '0004': '9',
      '0005': '10',
    },
    '00': {},
  };

  // Simple mapping for game types
  const gameTypeMap = {
    '0604': {
      name: 'fc21',
      gametypeId: 'rngfcg21ornothing',
      linkName: 'fc21',
      tableNumber: 5,
    },
    '0605': {
      name: 'fcb',
      gametypeId: 'rngfcgbaccarat',
      linkName: 'fcb',
      tableNumber: 1,
    },
    '0606': {
      name: 'fc21',
      gametypeId: 'rngfcg21ornothing',
      linkName: 'fc21',
      tableNumber: 5,
    },
    '0607': {
      name: 'livefcb',
      gametypeId: 'rngfcgbaccarat',
      linkName: 'fcb',
      tableNumber: 1,
    },
  };

  // Map table types to gameFeature
  const gameFeatureMap = {
    LD: GameTypeConstant.LIVEDEALER,
    LC: GameTypeConstant.RNG,
    PT: GameTypeConstant.RNG,
    '00': GameTypeConstant.LOBBY,
  };

  const ldTableIdMap = {
    '0000': 'None',
    '0001': 'fcg1w5h2dzb7b2rt',
    '0002': 'fcg1w5h2dzb87trt',
    '0003': 'fcg21dev99900001',
    '0004': 'fcg21dev99900002',
    '0005': 'fcg21dev99900003',
    '0006': 'fcg21dev99900004',
    '0007': 'fcg21dev99900005',
    '0008': 'fcg21dev99900006',
    '0009': 'fcg21dev99900007',
    '000A': 'fcg21nv8sv7rk1jk',
    '000B': 'fcg21nv8sv7rk2jk',
    '000C': 'fcg21nv8sv7rk3jk',
    '000D': 'fcg21nv8sv7rk4jk',
    '000E': 'fcg21nv8sv7rk5jk',
    '000F': 'fcg21nv8sv7rk6jk',
    '000G': 'fcg54bac237rk1tc',
    '000H': 'ld12allfcg21_001',
    '000I': 'ld22allfcg21_002',
    '000J': 'ld32allfcg21_003',
  };

  // Function to calculate roomId from tableIdKey for LC games
  const calculateRoomId = (tableIdKey: string): string => {
    // Only handle the last character for values 0-35
    const lastChar = tableIdKey[3];
    if (/^[0-9]$/.test(lastChar)) {
      return lastChar; // 0-9
    } else if (/^[A-Z]$/.test(lastChar)) {
      return (lastChar.charCodeAt(0) - 65 + 10).toString(); // A=10, B=11, etc.
    }
    return '0';
  };

  if (!gameId || gameId.length !== 16) {
    console.error('Invalid game ID format. Expected 16 characters.');
    return null;
  }

  // Extract key parts from the gameId
  const tableIdKey = gameId.substring(0, 4);
  // Bet Limit (characters 5-8)
  const betLimitCode = gameId.substring(4, 8);
  // Format / Table Type (characters 11-12)
  const tableType = gameId.substring(10, 12);
  // Game Type (characters 13-16)
  const gameTypeCode = gameId.substring(12, 16);

  console.log('Parsed game ID parts:', {
    tableIdKey,
    betLimitCode,
    tableType,
    gameTypeCode,
  });

  console.log('Checking mappings:', {
    hasGameType: !!gameTypeMap[gameTypeCode],
    hasTableType: !!betLimitMap[tableType],
    hasBetLimit: !!betLimitMap[tableType]?.[betLimitCode],
  });

  if (
    gameFeatureMap[tableType] !== GameTypeConstant.LOBBY &&
    (!gameTypeMap[gameTypeCode] ||
      !betLimitMap[tableType] ||
      !betLimitMap[tableType][betLimitCode])
  ) {
    console.error('Invalid game ID, unknown game type or bet limit.');
    return null;
  }

  // Get game info from map
  const gameInfo = gameTypeMap[gameTypeCode];

  // Get betlimit from map
  const betlimit = betLimitMap[tableType][betLimitCode];

  // Get game feature (RNG or LIVEDEALER)
  const gameFeature = gameFeatureMap[tableType];

  // Create rewriteURL and historyURL
  const rewriteURL = `!signin/viewer/mobile/lobby!${gameInfo.linkName}tables_${tableTypeMap[tableType]}_${gameInfo.tableNumber}`;
  const historyURL = rewriteURL;

  const tableId = tableType === 'LD' ? ldTableIdMap[tableIdKey] : undefined;
  const roomId = tableType === 'LC' ? calculateRoomId(tableIdKey) : undefined;

  return {
    gameName: gameInfo.name,
    gameFeature: gameFeature,
    betLimitId: betlimit,
    seatAvailable: gameInfo.tableNumber,
    newTable: 0,
    rewriteURL,
    historyURL,
    tableId,
    roomId,
    tableType,
  };
}

/**
 * Get game ID from URL if present, checking for gameid parameter
 * @returns Game ID string or null if not found
 */
export function getGameIdFromUrl(): string | null {
  try {
    console.log('Full URL:', window.location.href);
    console.log('Search string:', window.location.search);

    // Try both URLSearchParams and manual parsing
    const urlParams = new URLSearchParams(window.location.search);
    const manualParams = getQueryStrings();

    // Log all parameters for debugging
    const paramsObj: Record<string, string> = {};
    urlParams.forEach((value, key) => {
      paramsObj[key] = value;
    });
    console.log('URL Parameters:', paramsObj);
    console.log('Manual Parameters:', manualParams);

    // Try both 'gameid' and 'gameId' (case sensitivity might be an issue)
    const gameIdParam =
      urlParams.get('gameid') ||
      urlParams.get('gameId') ||
      manualParams['gameid'] ||
      manualParams['gameId'];

    console.log('Found gameIdParam:', gameIdParam);

    if (!gameIdParam) {
      console.log('No gameid parameter found in URL');
      return null;
    }

    // Check if the gameId is in the correct format (16 characters)
    if (gameIdParam.length === 16 && /^[0-9a-zA-Z]{16}$/.test(gameIdParam)) {
      console.log('Valid game ID found:', gameIdParam);
      return gameIdParam;
    }

    console.log('Invalid game ID format. Expected 16 characters.');
    return null;
  } catch (error) {
    console.warn('Error extracting game ID from URL:', error);
    return null;
  }
}

// Helper function to parse query string manually
function getQueryStrings(): Record<string, string> {
  const assoc: Record<string, string> = {};
  const queryString = location.search.substring(1);
  const keyValues = queryString.split('&');

  function decode(s: string): string {
    return decodeURIComponent(s.replace(/\+/g, ' '));
  }

  for (const i in keyValues) {
    if (keyValues.hasOwnProperty(i)) {
      const key = keyValues[i].split('=');
      if (key.length > 1) {
        assoc[decode(key[0])] = decode(key[1]);
      }
    }
  }
  return assoc;
}

// Map table types to tableTypeMap
export const tableTypeMap = {
  LD: 'livedealer',
  LC: 'livecasino',
  PT: 'private',
};
